<template>
  <div class="Contact">
    <el-row class="description-flex">
      <br>
      <el-col
        :sm="12"
        class="contact-col"
      >
        <el-table
          :data="tableData"
          border
          class="table"
          :header-cell-style="{ textAlign: 'center', padding: '7px 0px' }"
          :cell-style="{ textAlign: 'center', padding: '7px 0px' }"
          :show-header="false"
        >
          <el-table-column
            prop="name"
            label="聯絡方式"
          />
          <el-table-column
            prop="phone"
            label="聯絡方法"
          />
        </el-table>
      </el-col>
      <el-col
        :sm="12"
        style="display: flex;justify-content: center;align-items: center;"
      >
        <div class="fans">
          <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FGuardian17681%2F&tabs=timeline%2Cmessages&width=340&height=500&small_header=true&adapt_container_width=false&hide_cover=true&show_facepile=true&appId"
            height="500"
            style="border:none;overflow:hidden;"
            scrolling="no"
            frameborder="0"
            allowfullscreen="true"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          />
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
// @ is an alias to /src
import { reactive } from 'vue'
export default {
  name: 'Contact',
  setup () {
    const tableData = reactive([
      {
        name: '公司聯絡人',
        phone: '簡登豪先生'
      },
      {
        name: '手機號碼',
        phone: '0936-127-554'
      },
      {
        name: '市話',
        phone: '07-3852737'
      },
      {
        name: '公司地址',
        phone: '高雄市三民區九如一路４３６號３樓'
      },
      {
        name: '公司信箱',
        phone: 'guardian17681@gmail.com'
      },
      {
        name: 'LINE/FB',
        phone: 'ktcengen'
      },
      {
        name: '粉絲專頁',
        phone: '全泰然專業理賠服務團隊'
      }
    ])
    return {
      tableData
    }
  }
}
</script>
<style lang="scss" scoped>
$phones-media: 769px;
::v-deep .table tr td:nth-child(1) {
  background-color: #f5f7fa;
  font-weight: bold;
}
@media only screen and (max-width: $phones-media) {
  //手機版css
  .Contact {
    //background-image: url('../assets/Contact.jpg');
    background-size: cover;
    background-position: center;
    height: 100%;
    padding-top: 13vh;
    padding-left: 3vw;
    padding-right: 3vw;
    background-color: rgb(176, 235, 253);
    box-sizing: border-box;
  }
  .description-flex {
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
  }
  .item {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .fans {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .table {
    height: auto;
  }
  .contact-col {
    height: auto;
  }
}
@media only screen and (min-width: $phones-media) {
  //電腦版css
  .Contact {
    //background-image: url('../assets/Contact.jpg');
    background-size: cover;
    background-position: center;
    height: 100vh;
    padding-top: 10vh;
    padding-left: 5vw;
    padding-right: 5vw;
    background-color: rgb(209, 226, 231);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .description-flex {
    width: 65vw;
    background-color: white;
    padding: 15px;
    border-radius: 4px;
    filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.7));
    box-sizing: content-box;
  }
  ::v-deep .el-descriptions__body {
    width: 50%;
    margin-right: 01px !important;
    .is-bordered {
      width: 50%;
    }
  }
  .info {
    vertical-align: top;
  }
  .fans {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-table__body-wrapper {
    height: 100%;
    .el-table__body {
      height: 100%;
    }
  }
  .table {
    height: 100%;
  }
  .contact-col {
    height: 75vh;
  }
}
</style>
